import React from 'react';
import type { FC } from 'react';
import { SiteDev } from './site-flow/SiteDev.js';

export const SiteDevFlow: FC = () => {
  return <SiteDev />;
};
